import { Controller } from "@hotwired/stimulus"

// Remembers whether a <details> is open across page loads.
//
// <details data-controller="persist-details" data-persist-details-key-value="demo-panel"
//          data-action="toggle->persist-details#save" open> … </details>
export default class extends Controller {
  static values = { key: String }

  connect() {
    const stored = this.read()
    if (stored !== null) this.element.open = stored === "1"
  }

  save() {
    try {
      window.localStorage.setItem(this.storageKey, this.element.open ? "1" : "0")
    } catch (e) {
      // localStorage unavailable (private mode, disabled): the toggle still works for this page.
    }
  }

  read() {
    try {
      return window.localStorage.getItem(this.storageKey)
    } catch (e) {
      return null
    }
  }

  get storageKey() {
    return "details:" + this.keyValue
  }
}
